import React, { Component } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "./toastUtils";

// Functional wrapper to provide the navigate function
const ErrorBoundaryWrapper = ({ children }) => {
  const navigate = useNavigate();
  return <ErrorBoundary navigate={navigate}>{children}</ErrorBoundary>;
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      redirect: false,  // Track when to redirect
    };
  }

  // This lifecycle method is called when an error is thrown in a child component
  static getDerivedStateFromError() {
    // Immediately update state to show fallback UI
    return { hasError: true };
  }

  // This lifecycle method logs the error details and navigates back
  componentDidCatch(error, info) {
    // Log error details
    console.error("Error occurred:", error);
    console.error("Error info:", info);

    // Show toast notification with error message
    showToast({
      message: "An error occurred. Please try again later.",
      severity: "error",
    });

    // Use setTimeout to delay navigation until the error is caught
    setTimeout(() => {
      // Navigate back
      this.props.navigate(-1, { replace: true });

      // Force a state update to trigger re-render after navigation
      this.setState({ redirect: true });
    }, 0);
  }

  render() {
    if (this.state.hasError && !this.state.redirect) {
      // Don't render anything when an error occurs and before redirect
      return null;
    }
    return this.props.children;
  }
}

export default ErrorBoundaryWrapper;
